import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';
import Tools from './components/tools';

import BetterCorp from './views/bettercorp.co.za/router';
import BetterMarketing from './views/marketing.bettercorp.co.za/router';
import BetterStore from './views/store.bettercorp.co.za/router';
import BetterNetworks from './views/networks.bettercorp.co.za/router';
import BetterNews from './views/news.bettercorp.co.za/router';
import BetterWeb from './views/web.bettercorp.co.za/router';
import BetterFibre from './views/fibre.bettercorp.co.za/router';
import BetterTech from './views/tech.bettercorp.co.za/router';
import BetterStart from './views/start.bettercorp.co.za/router';
import SophosBetterTech from './views/sophos.bettertech.co.za/router';

Vue.use(Router);

const debugHostname: string = 'bettercorp.co.za';
let companyName: string = 'BetterCorp';
let companyThemeColour: string = 'rgb(0, 145, 234)';
let companyDescription: string = '';
let companyKeywords: string[] = [];
let companyIcons: {} = {};
let docBackgroundColour: string = '#FFF';

const GetRoutes = (): RouteConfig[] => {
  const thisHostname = (location.hostname !== 'localhost' ? location.hostname : debugHostname);
  let siteConfig = null;
  switch (thisHostname) {
    case 'bettercorp.co.za':
      siteConfig = BetterCorp;
      break;
    case 'start.bettercorp.co.za':
      siteConfig = BetterStart;
      break;
    case 'marketing.bettercorp.co.za':
      siteConfig = BetterMarketing;
      break;
    // case 'store.bettercorp.co.za':
    //   siteConfig = BetterStore;
    //   break;
    case 'networks.bettercorp.co.za':
      siteConfig = BetterNetworks;
      break;
    case 'news.bettercorp.co.za':
      siteConfig = BetterNews;
      break;
    case 'tech.bettercorp.co.za':
      siteConfig = BetterTech;
      break;
    case 'web.bettercorp.co.za':
      siteConfig = BetterWeb;
      break;
    case 'fibre.bettercorp.co.za':
      siteConfig = BetterFibre;
      break;
    case 'sophos.bettertech.co.za':
      siteConfig = SophosBetterTech;
      break;
  }

  if (siteConfig === null) {
    switch (location.hostname) {
      case 'betterweb.co.za':
        window.location.href = 'https://web.bettercorp.co.za';
        return [];
      case 'bettermarketing.co.za':
        window.location.href = 'https://marketing.bettercorp.co.za';
        return [];
      // case 'betterstore.co.za':
      //   window.location.href = 'https://store.bettercorp.co.za';
      //   return [];
      case 'bettertelecoms.co.za':
        window.location.href = 'https://telecoms.bettercorp.co.za';
        return [];
      case 'betternetworks.co.za':
        window.location.href = 'https://networks.bettercorp.co.za';
        return [];
      // case 'betternews.co.za':
      //   window.location.href = 'https://news.bettercorp.co.za';
      //   return [];
      case 'betterfibre.co.za':
      case 'betterfibre.com':
        window.location.href = 'https://fibre.bettercorp.co.za';
        return [];
      case 'bettertech.co.za':
        window.location.href = 'https://tech.bettercorp.co.za';
        return [];
    }
    window.location.href = 'https://bettercorp.co.za';
    return [];
  }
  companyName = siteConfig.config.companyName;
  companyThemeColour = siteConfig.config.companyThemeColour;
  companyDescription = siteConfig.config.companyDescription;
  companyKeywords = siteConfig.config.companyKeywords;
  companyIcons = siteConfig.config.companyIcons;
  docBackgroundColour = siteConfig.config.docBackgroundColour;

  return siteConfig.routes;
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: GetRoutes(),
});

let tempCompanyName: string = '';
let tempTheme: string = '';
let tempDescription: string = '';
let tempKeywords: string[] = [];
let tempIcons: {} = {};

const setTitle = (title: string | null, toRoute: any | undefined) => {
  let newName: string | null = (toRoute === undefined
    ? `${title} - ${companyName}`
    : toRoute.name !== null
      ? `${toRoute.name} - ${companyName}`
      : companyName);
  if (newName === tempCompanyName) {
    newName = null;
  } else {
    tempCompanyName = newName;
  }
  new Tools().setPageDetails({
    title: newName,
  });
};

Vue.prototype.$setTitle = setTitle;

router.beforeEach((to, from, next) => {
  setTimeout(() => {
    setTitle(null, to);
    let newDescription: string | null = companyDescription;
    if (newDescription === tempDescription) {
      newDescription = null;
    } else {
      tempDescription = newDescription;
    }
    let newThemeColour: string | null = companyThemeColour;
    if (newThemeColour === tempTheme) {
      newThemeColour = null;
    } else {
      tempTheme = newThemeColour;
    }
    let newKeywords: string[] | null = companyKeywords;
    if (newKeywords === tempKeywords) {
      newKeywords = null;
    } else {
      tempKeywords = newKeywords;
    }
    let newIcons: {} | null = companyIcons;
    if (newIcons === tempIcons) {
      newIcons = null;
    } else {
      tempIcons = newIcons;
    }
    new Tools().setPageDetails({
      theme: newThemeColour,
      description: newDescription,
      keywords: newKeywords,
      icons: newIcons,
      companyName,
      docBackgroundColour
    });
    window.scrollTo(0, 0);
  }, 100);
  next();
});

export default router;
